import { HashLink } from 'react-router-hash-link';
import '../styles/nav.css';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useState } from 'react';

const Nav = ({ role }) => {

    const navigate = useNavigate();
    const [navActive, setNavActive] = useState(false);

    const themes = {
        purple: {
            '--primary-color': '#994DA8',
            '--secondary-color': '#F7F1F9',
            '--primary-text-color': '#453145',
            '--secondary-text-color': '#6b219c',
            '--text-accent-color': '#E0D8E8',
            '--footer-color': '#563956',
            '--footer-anchor-accent': '#B394B3',
            '--footer-button-accent': '#854A96',
        },
        blue: {
            '--primary-color': '#3A7CA5',
            '--secondary-color': '#E8F4FB',
            '--primary-text-color': '#2C3E50',
            '--secondary-text-color': '#1E6091',
            '--text-accent-color': '#DCE6F0',
            '--footer-color': '#274C77',
            '--footer-anchor-accent': '#8FBAD9',
            '--footer-button-accent': '#206fa0',
        },
        green: {
            '--primary-color': '#3FA07A',
            '--secondary-color': '#E8F8F1',
            '--primary-text-color': '#2F3E34',
            '--secondary-text-color': '#287A59',
            '--text-accent-color': '#DDEDE5',
            '--footer-color': '#265C46',
            '--footer-anchor-accent': '#8ACFB3',
            '--footer-button-accent': '#1fab73',
        },
    };

    const setTheme = themeName => {
        const theme = themes[themeName];
        Object.keys(theme).forEach((key) => {
            document.documentElement.style.setProperty(key, theme[key]);
        });
    }

    const handleLogout = () => {
        sessionStorage.removeItem('accessToken');
        handleNavActive();
        navigate('/');
    }

    const handleNavActive = () => {
        if (navActive) setNavActive(false);
    }

    return (
        <>

            <div className="theme-buttons">
                <button
                    className="theme-btn purple"
                    onClick={() => setTheme('purple')}
                />
                <button
                    className="theme-btn blue"
                    onClick={() => setTheme('blue')}
                />
                <button
                    className="theme-btn green"
                    onClick={() => setTheme('green')}
                />
            </div>

            <nav className="nav">
                <Link className="logo-section" to="/" onClick={handleNavActive}>
                    <img src="/Ayushcare.png" alt="Ayush Care Services" className="logo" />
                    <div className="title">
                        <h2>Ayush Care Services </h2>
                        <sub>nexFarm</sub>
                    </div>
                </Link>

                <div className={`nav-links ${navActive ? 'nav-active' : ''}`}>

                    <Link to="/" onClick={handleNavActive}>Home</Link>

                    {role === "" &&
                        <>
                            <Link to="/login" onClick={handleNavActive}>Login</Link>
                            <Link to="/signup" onClick={handleNavActive}>Hospital registration</Link>
                            <Link to="/locations" onClick={handleNavActive}>Locations</Link>
                            <Link to="/services" onClick={handleNavActive}>Services</Link>
                            <HashLink smooth to="/#contact" onClick={handleNavActive}>Contact Us</HashLink>
                        </>
                    }

                    {role === "holder" &&
                        <>
                            <Link to="/edit" onClick={handleNavActive}>Edit Profile</Link>
                            <button onClick={handleLogout}>Logout</button>
                        </>
                    }

                    {role === "hospital" &&
                        <>
                            <Link to="/edit" onClick={handleNavActive}>Edit Profile</Link>
                            <button onClick={handleLogout}>Logout</button>
                        </>
                    }

                    {['village_cluster', 'mandal_officer', 'district_officer', 'area_manager'].includes(role) &&
                        <>
                            <Link to="/edit" onClick={handleNavActive}>Edit Profile</Link>
                            {role !== "village_cluster" && <Link to="/register" onClick={handleNavActive}>Register Employee</Link>}
                            <Link to="/registerHolder" onClick={handleNavActive}>Register Holder</Link>
                            <Link to="/incentives" onClick={handleNavActive}>Incentives</Link>
                            <Link to="/payouts">My Salary</Link>
                            <button onClick={handleLogout}>Logout</button>
                        </>
                    }

                    {role === "admin" &&
                        <>
                            <Link to="/unpaid" onClick={handleNavActive}>Unpaid Holders</Link>
                            <Link to="/unapproved" onClick={handleNavActive}>Unapproved Hospitals</Link>
                            <Link to="/registerEmployee" onClick={handleNavActive}>Register Employee</Link>
                            <Link to="/payouts">Payouts</Link>
                            <button onClick={handleLogout}>Logout</button>
                        </>
                    }

                </div>

                <div className="nav-toggle" onClick={() => { setNavActive(prev => !prev) }}>
                    &#9776;
                </div>

            </nav >

            <Outlet />

        </>
    )
}

export default Nav;
